import * as util from "../../util/api";
import { lastActiveProfileForGame, } from "../profile_management/selectors";
import { findGameEntry } from "./gameSupport";
import { LoadOrderSerializationError, LoadOrderValidationError, } from "./types/types";
import { setValidationResult } from "./actions/session";
import { currentGameMods, currentLoadOrderForProfile } from "./selectors";
export const toExtendedLoadOrderEntry = (api) => {
    return (entry, index) => {
        const state = api.getState();
        const mods = currentGameMods(state);
        const fileId = mods[entry?.modId]?.attributes?.fileId;
        return { ...entry, index, fileId };
    };
};
export function isModInCollection(collection, mod) {
    if (collection.rules === undefined) {
        return false;
    }
    return (collection.rules.find((rule) => util.testModReference(mod, rule.reference)) !== undefined);
}
export async function genCollectionLoadOrder(api, gameEntry, mods, profileId, collection) {
    const state = api.getState();
    let loadOrder = [];
    try {
        const prev = currentLoadOrderForProfile(state, profileId);
        loadOrder = await gameEntry.deserializeLoadOrder();
        loadOrder = loadOrder.filter((entry) => collection !== undefined
            ? isValidMod(mods[entry.modId]) &&
                isModInCollection(collection, mods[entry.modId])
            : isValidMod(mods[entry.modId]));
        const validRes = await gameEntry.validate(prev, loadOrder);
        assertValidationResult(validRes);
        if (validRes !== undefined) {
            throw new LoadOrderValidationError(validRes, loadOrder);
        }
    }
    catch (err) {
        return Promise.reject(err);
    }
    return Promise.resolve(loadOrder);
}
export function isValidMod(mod) {
    return mod !== undefined && mod.type !== "collection";
}
function reportError(api, errorMessage, errDetails, allowReport = true) {
    const errorId = errorMessage + "notifId";
    api.showErrorNotification(errorMessage, errDetails, {
        allowReport,
        id: errorId,
    });
}
export async function errorHandler(api, gameId, err) {
    const gameEntry = findGameEntry(gameId);
    const allowReport = !gameEntry.isContributed &&
        !(err instanceof util.ProcessCanceled) &&
        !(err instanceof util.DataInvalid) &&
        !(err instanceof util.UserCanceled);
    if (err instanceof LoadOrderValidationError) {
        const invalLOErr = err;
        const profileId = lastActiveProfileForGame(api.getState(), gameId);
        api.store.dispatch(setValidationResult(profileId, invalLOErr.validationResult));
        const errorMessage = "Load order failed validation";
        const details = {
            message: errorMessage,
            loadOrder: invalLOErr.loadOrderEntryNames,
            reasons: invalLOErr.validationResult.invalid.map((invl) => `${invl.id} - ${invl.reason}\n`),
        };
        reportError(api, errorMessage, details, allowReport);
    }
    else if (err instanceof LoadOrderSerializationError) {
        const serErr = err;
        const errMess = "Failed to serialize load order";
        const details = {
            loadOrder: serErr.loadOrder,
        };
        reportError(api, errMess, details, allowReport);
    }
    else {
        reportError(api, "Failed load order operation", err, allowReport);
    }
    return Promise.resolve();
}
export function assertValidationResult(validRes) {
    if (validRes === undefined) {
        return;
    }
    if (Array.isArray(validRes) ||
        validRes?.invalid === undefined) {
        throw new TypeError("Received incorrect/invalid return type from validation function; " +
            "expected object of type IValidationResult");
    }
}
